window.switchButton = function () {
  $(document).ready(function () {
    bindSwitchEvents();
  });

  const bindSwitchEvents = function () {
    const tabContent = $('.jsSwitchButtonTabListItem');
    const panelLink = $('.jsSwitchButton');

    tabContent.eq(0).addClass('active');
    let slideButtonValues = ["0%", "47.5%"];
    let i = 0;

    const slideButton = function (value) {
      panelLink.eq(i).on('click', function () {
        panelLink.removeClass('active');
        $(this).addClass('active');
        $('.jsSwitchButtonTab').animate({left: value}, 500);
      })
    };

    while (i < slideButtonValues.length) {
      slideButton(slideButtonValues[i]);
      i++
    }
  };
};
